import { IHotelPreferenceCategory, INoteTopic, IOfferCategory, ITimePeriod } from "services/models";
import { IPreferencesApiService } from "services/models/ApiService";
import { ApiService } from "./ApiService";
import { authorizedFetchAsJson } from "./misc";

export class PreferencesApiService implements IPreferencesApiService {
  constructor(private accessToken: () => Promise<string>) {}

  getTimePeriod(): Promise<ITimePeriod[]> {
    return authorizedFetchAsJson(`${ApiService.v1Url}/settings/periods`, this.accessToken);
  }

  getOfferCategories(): Promise<IOfferCategory[]> {
    return authorizedFetchAsJson(`${ApiService.v1Url}/offers/categories`, this.accessToken);
  }

  getNoteTopics(): Promise<INoteTopic[]> {
    return authorizedFetchAsJson(`${ApiService.v1Url}/topics`, this.accessToken);
  }

  getPreferences(): Promise<IHotelPreferenceCategory[]> {
    return authorizedFetchAsJson(`${ApiService.v1Url}/hotel/booking/preferences`, this.accessToken);
  }
}
